import RoboticArmIcon from './RoboticArmIcon'

export default RoboticArmIcon
